import React, { useEffect, useState } from 'react';
import { useLenis } from '../../hooks/useLenis';

const ROOMS = [
  { id: 'room-hero', title: 'Entrance' },
  { id: 'room1', title: 'Room 1' },
  { id: 'room2', title: 'Room 2' },
  { id: 'room3', title: 'Immersion' },
  { id: 'gallery', title: 'Gallery' },
];

export const RoomNav = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { scrollTo } = useLenis();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 3;
      
      ROOMS.forEach((room, index) => {
        const el = document.getElementById(room.id);
        if (el) {
          const top = el.offsetTop;
          const bottom = top + el.offsetHeight;
          if (scrollPos >= top && scrollPos < bottom) {
            setActiveIndex(index);
          }
        }
      });
    };

    window.addEventListener('scroll', () => requestAnimationFrame(handleScroll), { passive: true });
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e, index, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) scrollTo(el);
  };

  return (
    <nav className="fixed z-40 flex-col hidden gap-3 -translate-y-1/2 md:flex right-6 top-1/2">
      {ROOMS.map((room, index) => (
        <a
          key={room.id}
          href={`#${room.id}`}
          onClick={(e) => handleClick(e, index, room.id)}
          title={room.title}
          className={`w-3 h-3 rounded-full border-2 border-[var(--accent)] transition-all duration-300 ${
            activeIndex === index 
              ? 'bg-[var(--accent)] scale-125' 
              : 'bg-transparent hover:bg-[var(--accent)]/50'
          }`}
        />
      ))}
    </nav>
  );
};